import React from 'react'
import style from "css/address.module.css";
import { ReactComponent as NoResultIcon } from "asset/mobile/no_result_icon.svg";
import { useTranslation } from 'react-i18next';

function NoAddress() {
    const { t } = useTranslation();
    return (
        <div className={style.noMsg_container}>
            <div className={style.noMsg_img}><NoResultIcon /></div>
            <div className={style.noMsg_main}>
                {t("MESSAGE.CONTACT_PAGE_1")}<br />
                {t("MESSAGE.CONTACT_PAGE_2")}
            </div>
            <div className={style.noMsg_sub}>{t("MESSAGE.CONTACT_PAGE_3")}</div>
        </div>
    )
}

export default NoAddress
